import type { IHttpClientService } from "@/shared/services/http_client/interfaces/IHttpClientService.ts";
import type { ISecurityRepository } from "@/app/security/interfaces/ISecurityRepository";
import type { LoginModel, SecurityModel } from "@/app/security/models/SecurityModel";

export class SecurityRepository implements ISecurityRepository {
  private readonly BASE_URL: string = "/auth";

  constructor(private readonly httpClientService: IHttpClientService) {}

  async login(securityModel: SecurityModel): Promise<LoginModel> {
    return await this.httpClientService.post(`${this.BASE_URL}/login`, securityModel);
  }

  async logout(refreshToken: string): Promise<void> {
    return await this.httpClientService.post(`${this.BASE_URL}/logout`, {
      refreshToken: refreshToken,
    });
  }
}
